
import { useLocation,Outlet,useNavigate } from 'react-router-dom'
import Sidebar from './Sidebar';
import { Dropdown,Layout,Menu,Space } from 'antd';
import { useRef,useEffect,useState } from "react";
import { createFromIconfontCN,TeamOutlined,UserOutlined,DeploymentUnitOutlined,ReadOutlined,HomeOutlined,LineChartOutlined, AppstoreOutlined ,GiftOutlined,ProfileOutlined,CaretDownOutlined,CustomerServiceOutlined } from '@ant-design/icons';
import MerchantList from "../pages/login/components/merchantList";
import ChangePassword from "../pages/login/components/changePassword";
import type { MenuProps } from 'antd';
import { useSelector } from 'react-redux';
import { RootType } from '@/store';
import { menuitems } from '@/constant';
import { menuMap } from "@/constant"
const { Sider } = Layout;
import './index.css'
type MenuItem = Required<MenuProps>['items'][number]
const AcitivityIcon = createFromIconfontCN({
  scriptUrl: '/font.js', // 在 iconfont.cn 上生成
});
const layout: React.FC = () => {
  const { role,userName,merchantName,menu } = useSelector((state:RootType)=>state.user)
  const router = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const dialog = useRef<any>(null);
  const changePasswordDialog = useRef<any>(null);
  const items: MenuProps['items'] = [
    {
      key: 'changePassword',
      label: (
        <span>
          修改密码
        </span>
      ),
    },
    {
      key: 'exit',
      label: (
        <span>
          退出
        </span>
      ),
    },
  ];

  const iconItem = [
      <LineChartOutlined />,
      <AcitivityIcon type="fulu-zhanghuguanli" style={{fontSize:'14px' }} />,
      <HomeOutlined />,
      <DeploymentUnitOutlined />,
      <AcitivityIcon type="fulu-activity-line" style={{fontSize:'14px' }} />,
      <AcitivityIcon type="fulu-quanyi1" style={{fontSize:'14px' }} />,
      <GiftOutlined />,
      <UserOutlined />,
      <ProfileOutlined />,
      <AcitivityIcon type="fulu-shouhou" style={{fontSize:'14px' }} />,
      <CustomerServiceOutlined />,
  ];
  const allMenuList:MenuItem[] = menuitems.map((item, index) => {
    return {
      ...item,
      icon: iconItem[index],  
    }
  }).filter(ite=>{
    return (menu && menu[menuMap[ite.key]]) ? menu[menuMap[ite.key]]?.view : false
  })


 

  const onClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'changePassword') {
      changePasswordDialog.current?.open();
    } else {
      localStorage.removeItem('token')
      localStorage.removeItem('merchantId')
      router('/')
    }
  };

  const [collapsed, setCollapsed] = useState(false);
  const [selectKey, setSelectKey] = useState<string>('');
  useEffect(() => {
    setSelectKey(pathname)
  },[pathname])
  return (
    <div className="contanier">
      <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
        <div className='sysTitle'>
          <h2>1+N 权益管理系统</h2>
        </div>
        <div className='menuBox'>
        <Menu theme="dark" mode="inline" defaultSelectedKeys={[selectKey]} selectedKeys={[selectKey]} items={allMenuList} onClick={(e)=>{ router(e.key) }} />
        </div>
          
        </Sider>
      <div className="main">
      <div className='header'>
          <Space size='large'>
            <Space size='small' style={{ cursor: "pointer" }} onClick={()=>{
              dialog.current?.open();
            }}>
              <span>{merchantName}</span>
              <CaretDownOutlined />
            </Space>
            <Dropdown menu={{ items, onClick }} placement="bottom">
              <Space size='small' className='userInfo'>
                <UserOutlined style={{ fontSize:'20px' }}/>
                <span>
                  {userName}
                </span>
              </Space>
            </Dropdown> 
          </Space>
        </div>
        <Outlet />
      </div>
      <MerchantList ref={dialog} />
      <ChangePassword ref={changePasswordDialog} />
    </div>
  );
};

export default layout; 